import { render, staticRenderFns } from "./UploadFileForm.vue?vue&type=template&id=7b2342d1&scoped=true&"
import script from "./UploadFileForm.vue?vue&type=script&lang=js&"
export * from "./UploadFileForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileForm.vue?vue&type=style&index=0&id=7b2342d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2342d1",
  null
  
)

export default component.exports